import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * App-wide realtime (WebSocket) connection status, derived from all live
 * namespaces by the socket manager. Drives the connection-status banner.
 * Transient runtime state — intentionally NOT persisted.
 */
export type ConnectionStatus = "connected" | "reconnecting" | "disconnected";

interface ConnectionStatusState {
  status: ConnectionStatus;
}

const initialState: ConnectionStatusState = {
  status: "connected",
};

export const CONNECTION_STATUS_SLICE_NAME = "connectionStatus";

const connectionStatusSlice = createSlice({
  name: CONNECTION_STATUS_SLICE_NAME,
  initialState,
  reducers: {
    setConnectionStatus(state, action: PayloadAction<ConnectionStatus>) {
      state.status = action.payload;
    },
  },
});

export const { setConnectionStatus } = connectionStatusSlice.actions;

export const selectConnectionStatus = (state: {
  [CONNECTION_STATUS_SLICE_NAME]: ConnectionStatusState;
}) => state[CONNECTION_STATUS_SLICE_NAME].status;

export default connectionStatusSlice.reducer;
